import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_DischargeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_DischargeSummary' className='file-pdf-document'>

            <div className='file-template'>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge meeting held with Client/Family/Legal Guardian:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="cbYes" id="cbYes" className='add-only' value="Yes" />
                            Yes
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbNo" id="cbNo" className='add-only' value="No" />
                            No
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbUnplannedDischarge" id="cbUnplannedDischarge" className='add-only' value="Unplanned Discharge" />
                            Unplanned Discharge
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" name="cbSpecify" id="cbSpecify" className='add-only' value="If no, specify:" />
                    If no, specify:
                    <textarea name="txtSpecify" id="txtSpecify" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Insurance Type:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" name="cbAMG" id="cbAMG" className='add-only' value="AMG" />
                            AMG</td>
                        <td className='w-250'><input type="checkbox" name="cbPS" id="cbPS" className='add-only' value="PS" />
                            PS</td>
                        <td className='w-250'><input type="checkbox" name="cbWC" id="cbWC" className='add-only' value="WC" />
                            WC</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" name="cbMEDICAID" id="cbMEDICAID" className='add-only' value="MEDICAID CS" />
                            MEDICAID CS</td>
                        <td className='w-250'><input type="checkbox" name="cbInactive" id="cbInactive" className='add-only' value="Inactive" />
                            Inactive</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbOther" id="cbOther" className='add-only' value="Other" />
                            Other: <input type="text" name="txtOther" id="txtOther" className='add-only' />

                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Presenting Condition/Reason for Treatment:</span>
                    <textarea name="txtPresentingCondition" id="txtPresentingCondition" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>New Findings during Course of Services, if applicable</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(medications, new DX, new SX, resolution of SX, etc.):</span>
                </p>
                <p className='w-750'>
                    <textarea name="txtNewFindings" id="txtNewFindings" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Services Received:</span>
                    <textarea name="txtServicesReceived" id="txtServicesReceived" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths:</span>
                    <textarea name="txtStrengths" id="txtStrengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs:</span>
                    <textarea name="txtNeeds" id="txtNeeds" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities:</span>
                    <textarea name="txtAbilities" id="txtAbilities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences:</span>
                    <textarea name="txtPreferences" id="txtPreferences" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Progress Towards Goals and Gains Achieved:</span>
                </p>
                <p className='w-750'>
                    <textarea name="txtGainsAchieved" id="txtGainsAchieved" className='add-only' placeholder="1"></textarea>
                </p>
                <p className='w-750'>
                    <textarea name="txtGainsAchieved1" id="txtGainsAchieved1" className='add-only' placeholder="2"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Reason for Discharge/Transition:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(a synopsis of treatment and results of services, Date of admission Description
                        of services provided, Presenting condition, the extent to which goals and objectives were achieved, Reasons for
                        discharge, Follow up contact information, Recommendations for services and supports, Date of discharge)
                    </span>
                </p>
                <p className='w-750'>
                    <textarea name="txtTransition" id="txtTransition" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbIndividualTherapy" id="cbIndividualTherapy" className='add-only' value="Individual Therapy" />
                            Individual Therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbFamilyTherapy" id="cbFamilyTherapy" className='add-only' value="Family Therapy" />
                            Family Therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbCSI" id="cbCSI" className='add-only' value="CSI" />
                            CSI
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-380'>
                            <input type="checkbox" name="cbOtherServices" id="cbOtherServices" className='add-only' value="Other Services" />
                            Other Services:
                            <input type="text" name="txtOtherServices" id="txtOtherServices" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Input Received From</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Check all that apply):</span>
                </p>
                <table>
                    <tr>
                        <td className='w-300'>
                            <input type="checkbox" name="cbLegallyAuthorized" id="cbLegallyAuthorized" className='add-only' value="Legally Authorized Representative" />
                            Legally Authorized Representative
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbParent" id="cbParent" className='add-only' value="Parent/Guardian" />
                            Parent/Guardian
                        </td>
                        <td className='w-70'>
                            <input type="checkbox" name="cbClient" id="cbClient" className='add-only' value="Client" />
                            Client
                        </td>
                        <td className='w-70'>
                            <input type="checkbox" name="cbStaff" id="cbStaff" className='add-only' value="Staff" />
                            Staff
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" name="cbReferralSource" id="cbReferralSource" className='add-only' value="Referral Source, specify:" />
                    Referral Source, specify:
                    <textarea name="txtReferralSource" id="txtReferralSource" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbOtherCommunity" id="cbOtherCommunity" className='add-only' value="Other Community Services, specify:" />
                    Other Community Services, specify:
                    <textarea name="txtOtherCommunity" id="txtOtherCommunity" className='add-only'></textarea>
                </p>
                <h3>Final Diagnosis:</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Axis I
                    </span>
                    <input type="text" name="txtAxis_1" id="txtAxis_1" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Psychological Date of Testing:</span>
                            <input type="date" name="txtDateOfTesting" id="txtDateOfTesting" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Psychiatric Date of Testing:</span>
                            <input type="date" name="txtDateOfTesting1" id="txtDateOfTesting1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge Medications:</span>
                    <textarea name="txtDischargeMedications" id="txtDischargeMedications" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ongoing Recommendations:</span>
                    <textarea name="txtOngoingRecommendations" id="txtOngoingRecommendations" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Living situation at Discharge:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbIndependentLiving" id="cbIndependentLiving" className='add-only' value="Independent living" />
                            Independent living
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbFosterHome" id="cbFosterHome" className='add-only' value="Foster home/Guardian" />
                            Foster home/Guardian
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbPrivateResidence" id="cbPrivateResidence" className='add-only' value="Private residence" />
                            Private residence
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbUnknown" id="cbUnknown" className='add-only' value="Unknown" />
                            Unknown
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Referral to</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(include contact, telephone number location, hours/days of operation):</span>
                </p>
                <p className='w-750'>
                    County:
                    <input type="text" name="txtCounty" id="txtCounty" className='add-only' />
                    Date of referral:
                    <input type="date" name="txtDateOfReferral" id="txtDateOfReferral" className='add-only' />
                </p>
                <p className='w-750'>
                    All agencies listed below provide services Monday-Friday from 9:00am-5:00pm
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbFamilyIntervention" id="cbFamilyIntervention" className='add-only' value="FamilyInterventionSpecialists848HiramAcworthHighwayHiramGeorgia30141Ph7702226622" />
                    Family Intervention Specialists- 848 Hiram Acworth Highway, Hiram, Georgia 30141-Ph: 770 222-6622
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbSocialServices" id="cbSocialServices" className='add-only' value="UnderdueSocialServices165BurkeSt109StockbridgeGA02813464Ph7703899886" />
                    Underdue Social Services-165 Burke St # 109 Stockbridge, GA 30281-3464 Ph:(770) 389-9886
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbCourt" id="cbCourt" className='add-only' value="JuvCourtClaytonFultonDekalbHenryetc" />
                    Juv. Court-Clayton, Fulton, Dekalb, Henry, etc.
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbClaytonCounty" id="cbClaytonCounty" className='add-only' value="ClaytoCountyCSB853BattleCreekRPh7704736124JonesboroGeorgia" />
                    Clayton County CSB-853 Battle Creek Rd -Ph: 770 473-6124: Jonesboro, Georgia
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbChrisKids" id="cbChrisKids" className='add-only' value="ChrisKids3109ClairmontRdNESteAAtlantaGA30329Ph4043244190" />
                    Chris Kids - 3109 Clairmont Rd. NE, Ste. A Atlanta, GA 30329 Ph: (404) 324-4190
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbYouthVillages" id="cbYouthVillages" className='add-only' value="YouthVillagesInnerHarbor4685DorsettShoalsRoadDouglasvilleGA30135Ph7709422391" />
                    Youth Villages (Inner Harbor) 4685 Dorsett Shoals Road Douglasville, GA 30135 Ph: (770) 942-2391
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbYoungFamily" id="cbYoungFamily" className='add-only' value="YMCAMentoringTheVillagesatCarverFamilyYMCA1600PryorRdAtlantaGA30315Ph4046359622" />
                    YMCA/Mentoring The Villages at Carver Family YMCA 1600 Pryor Rd. Atlanta, GA 30315 Ph: (404) 635-9622
                    Andrew and Walter Young Family YMCA-2220 Campbellton Rd.-Atlanta, GA 30311(404) 523-9622
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbPleaseSpecify" id="cbPleaseSpecify" className='add-only' value="OtherPleaseSpecify" />
                    Other (please specify)
                    <textarea name="txtPleaseSpecify" id="txtPleaseSpecify" className='add-only'></textarea>
                </p>
                <h3>30-day Follow up by NHBC:</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Person contacted:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-300'>
                            <input type="checkbox" name="cbLegallyAuthorized1" id="cbLegallyAuthorized1" className='add-only' value="Legally Authorized Representative" />
                            Legally Authorized Representative
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbParent1" id="cbParent1" className='add-only' value="Parent/Guardian" />
                            Parent/Guardian
                        </td>
                        <td className='w-70'>
                            <input type="checkbox" name="cbClient1" id="cbClient1" className='add-only' value="Client" />
                            Client
                        </td>
                        <td className='w-70'>
                            <input type="checkbox" name="cbStaff1" id="cbStaff1" className='add-only' value="Staff" />
                            Staff
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" name="cbReferralSource1" id="cbReferralSource1" className='add-only' value="Referral Source, specify:" />
                    Referral Source, specify:
                    <textarea name="txtReferralSource1" id="txtReferralSource1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbOtherCommunity1" id="cbOtherCommunity1" className='add-only' value="Other Community Services, specify:" />
                    Other Community Services, specify:
                    <textarea name="txtOtherCommunity1" id="txtOtherCommunity1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Was contact with the referred provider made by Client/Parent/Legal Guardian:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="cbYes1" id="cbYes1" className='add-only' value="Yes" />
                            Yes
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbNo1" id="cbNo1" className='add-only' value="No" />
                            No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" name="cbContactNotMade" id="cbContactNotMade" className='add-only' value="If contact not made, specify" />
                    If contact not made, specify
                    <textarea name="txtContactNotMade1" id="txtContactNotMade1" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbAccepted" id="cbAccepted" className='add-only' value="Accepted" />
                            Accepted &nbsp;
                            <input type="checkbox" name="cbDeclined" id="cbDeclined" className='add-only' value="Declined" />
                            Declined
                        </td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>&nbsp;</td>
                        <td className='small w-200'>CLINICAN SIGNATURE</td>
                        <td className='small w-150'>TITLE</td>
                        <td className='small w-150'>DATE</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbAccepted1" id="cbAccepted1" className='add-only' value="Accepted" />
                            Accepted &nbsp;
                            <input type="checkbox" name="cbDeclined1" id="cbDeclined1" className='add-only' value="Declined" />
                            Declined
                        </td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>&nbsp;</td>
                        <td className='small w-200'>CLINICAN SIGNATURE</td>
                        <td className='small w-150'>TITLE</td>
                        <td className='small w-150'>DATE</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbAccepted2" id="cbAccepted2" className='add-only' value="Accepted" />
                            Accepted &nbsp;
                            <input type="checkbox" name="cbDeclined2" id="cbDeclined2" className='add-only' value="Declined" />
                            Declined
                        </td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>&nbsp;</td>
                        <td className='small w-200'>CLINICAN SIGNATURE</td>
                        <td className='small w-150'>TITLE</td>
                        <td className='small w-150'>DATE</td>
                    </tr>
                </table>


            </div>
        </form>

    )
} 
